module.exports = __webpack_public_path__ + "img/section4_m.ae460c30.jpg";